import React from 'react'
import { SyncOutlined } from '@ant-design/icons'

const LoadingSpinner = (props) => (
  <div className="loading-spinner">
    {props.text || 'Loading'} &nbsp;
    <SyncOutlined style={{ fontSize: '28px', color: '#1890ff' }} spin />
  </div>
)

export default LoadingSpinner
